$(document).ready(function(){
    loadCustomProductsData();
});

document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    loadCustomProductsData();
    
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    loadCustomProductsData();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    loadCustomProductsData();
});

function loadCustomProductsData() {
    $.getJSON('/user/documents/crypto.json?v='+new Date().getMinutes(), function(data) {
        var jsonData = JSON.stringify(data);
        sessionStorage.setItem('allProductsBitcoinEN', jsonData);
        console.log("Data byla úspěšně načtena a uložena do sessionStorage.");
        customProduct();
        navratnost();
    }).fail(function() {
        console.error("Chyba při načítání dat ze souboru.");
    });
}

function navratnost(){
    $(document).ready(function(){
        if($('.type-detail').length){
            var sku = $('#product-detail-form meta[itemprop="sku"]').attr('content').trim()
            var customProductsData = sessionStorage.getItem('allProductsBitcoinEN');
            if (customProductsData) {
                customProductsData = JSON.parse(customProductsData);
            } else {
                console.error("Data nebyla nalezena v sessionStorage");
                return;
            }
            var productData = customProductsData.find(product => product.CODE === sku);
            if (typeof productData !== 'undefined') {
                var navratnost = productData.NAVRATNOST;
                if (navratnost) {
                    // Pokud je navratnost objekt, převedeme jej na pole
                    if (!Array.isArray(navratnost)) {
                        navratnost = [navratnost];
                    }
                    $('.p-info-wrapper').append($('.returnMining'))
                    var navratnostHtml = '';
                    console.log(navratnost)
                    navratnost.forEach(function(item) {
                        navratnostHtml += item.NAME + ' - ' + item.VALUE + '<br>';
                        $('.returnMining .return ul').append('<li data-currency="'+item.NAME.normalize('NFD').replace(/[^\w]/g, '').toLowerCase()+'"><span><img src="/user/documents/upload/sablona-nemazat/krypto/'+item.NAME.normalize('NFD').replace(/[^\w]/g, '').toLowerCase()+'.svg">'+item.NAME +' - The return is '+item.VALUE +'. Daily profitability is '+item.ZISKOVOST +'</span></li>')
                    });
                    $('.returnMining .return ul li').first().addClass('active')
                    $('.returnMining .return>div').first().addClass('active')
                    $('.p-final-price-wrapper .price-final').append('<span class="show-tooltip" data-title="'+returnabilityText+':<br>'+navratnostHtml+'" data-original-title="'+returnabilityText+':<br>'+navratnostHtml+'">i</span>');
                    initTooltips();
                } else {
                    console.warn("Parametr 'návratnost' nebyl nalezen pro SKU " + (productData.SKU || 'neznámé SKU'));
                }
            } else {
                console.warn("Data pro SKU " + sku + " nebyla nalezena.");
            }
        }
    })
    
    
}

$(document).on('click', '.returnMining .return ul li',function(){
    $('.returnMining .return ul li').removeClass('active')
    $('.returnMining .return div').removeClass('active')
    $(this).addClass('active')
    $('.returnMining .return div[data-currency="'+$(this).attr('data-currency')+'"]').addClass('active')
})

function customProduct() {
    if($('.product').length){
        $('.product').each(function() {
            var sku = $(this).find('span[data-micro="sku"]').text().trim();
            $(this).find('.p').append('<span class="btn_toggle"></span>');
            var customProductsData = sessionStorage.getItem('allProductsBitcoinEN');
            if (customProductsData) {
                customProductsData = JSON.parse(customProductsData);
            } else {
                console.error("Data nebyla nalezena v sessionStorage");
                return;
            }

            var productData = customProductsData.find(product => product.CODE === sku);
        
        

            if (typeof productData !== 'undefined') {
                var paramsHtml = '<div class="specialParams">';
                
                // Přidání parametrů
                if (productData.PARAMETRY) {
                    for (const key in productData.PARAMETRY) {
                        if (productData.PARAMETRY.hasOwnProperty(key)) {
                            if (typeof productData.PARAMETRY[key].NAZEV !== 'undefined') {
                                paramsHtml += '<div class="specialParamsRow productParams"><div class="left">' + productData.PARAMETRY[key].NAZEV + '</div><div class="right">' + productData.PARAMETRY[key].HODNOTA + '</div></div>';
                            }
                        }
                    }
                }

                // Přidání návratnosti
                
                var navratnost = productData.NAVRATNOST;
           
                if (navratnost) {
                    // Pokud je navratnost objekt, převedeme jej na pole
                    if (!Array.isArray(navratnost)) {
                        navratnost = [navratnost];
                    }
                    navratnost.forEach(function(item) {
                        if(item.NAME === 'KASPA'){
                            paramsHtml += '<div class="specialParamsRow"><div class="left">'+returnabilityText+'</div><div class="right">' + item.VALUE + '</div></div>'
                        }
                       
                        
                       
                    });
                }
                paramsHtml += '</div>';
                $(this).find('.p-bottom').prepend(paramsHtml);
            }  else {
                    var sku = productData.SKU || 'neznámé SKU'; // Předpokládá, že SKU je v productData, případně nastaví 'neznámé SKU'
                    console.warn("Data pro SKU " + sku + " nebyla nalezena.");
                }
        
            
            
            if ($(this).find('.price-standard').length) {
                $(this).find('.prices').prepend($(this).find('.price-standard'));
            }
            if($(this).find('.flags.flags-default').length){
                $(this).find('.p').prepend($(this).find('.flags.flags-default'));
            } else {
                $(this).find('.p').prepend('<div class="flags flags-default"></div>');
            }
            $(this).find('.p').prepend($(this).find('a.name'));
        });
    }
}